import { DateTime } from "luxon";

import { HostedPagesDayPicker } from "../../components/HostedPagesDayPicker";

export type HostedPagesAppointableCalendarPickerProps = {
  currentDate: DateTime;
  setCurrentDate: (date: DateTime) => void;
};

const HostedPagesAppointableCalendarPicker = ({
  currentDate,
  setCurrentDate,
}: HostedPagesAppointableCalendarPickerProps) => {
  return (
    <div className="bg-gray-0 flex w-full flex-col items-center gap-2 border-b border-gray-300 p-4 lg:flex-row lg:justify-between lg:px-28 dark:border-gray-700 dark:bg-gray-950">
      <div className="dark:text-gray-0 text-xl font-semibold text-gray-950 max-lg:w-[min(32rem,100vw-2rem)]">
        {currentDate.toLocaleString({
          weekday: "short",
          month: "short",
          day: "numeric",
        })}
      </div>
      <HostedPagesDayPicker
        className="w-[min(32rem,100vw-2rem)]"
        currentDate={currentDate}
        setCurrentDate={setCurrentDate}
      />
      <div className="invisible max-lg:hidden">
        {currentDate.toLocaleString({
          weekday: "short",
          month: "short",
          day: "numeric",
        })}
      </div>
    </div>
  );
};

export default HostedPagesAppointableCalendarPicker;
